import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import configureStore from './store/configureStore';
import { setCurrentUser } from './store/actions/authActions';
import { readAuthSession } from './utils/authSession';
import history from 'utils/history';
import * as Sentry from '@sentry/react';
import { initSentry } from 'utils/sentry';

import { createGlobalStyle } from 'styled-components';
import { global } from '@leapeasy/ui-kit';
const GlobalStyle = createGlobalStyle`${global.GlobalStyle}`;

const root = ReactDOM.createRoot(document.getElementById('root'));

const initialState = {};
const store = configureStore(initialState, history);

const bootSession = readAuthSession();
if (bootSession.user) {
  store.dispatch(setCurrentUser(bootSession.user));
}

initSentry();

root.render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <Provider store={store}>
      <ReduxRouter history={history} routerSelector={(state) => state.get('router')}>
        <GlobalStyle />
        <App />
      </ReduxRouter>
    </Provider>
  </Sentry.ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
